export const init = () => {
    const counter = document.querySelectorAll('.js-character-count');
    const textField = document.querySelectorAll('.js-textarea');

    textField.forEach((item, i) => {
        item.addEventListener('input', () => {
            counter.forEach((curr, j) => {
                if (i === j) {
                    curr.innerHTML = item.value.length;
                }
            })
        })
    })
}